import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import { NavigateTo } from '@contexts/components/NavigateTo'

import { withSuspense } from '@HOCs/withSuspense'

import { About } from '@pages/LandingPage/About'
import { Blog } from '@pages/LandingPage/Blog'
import { BlogPostView } from '@pages/LandingPage/BlogPostView'
import { ContactUs } from '@pages/LandingPage/ContactUs'
import { Features } from '@pages/LandingPage/Features'
import { Home } from '@pages/LandingPage/Home'
import { Press } from '@pages/LandingPage/Press'
import { TechVendorsBenefits } from '@pages/LandingPage/TechVendorsBenefits'
import { TechVendorsFAQ } from '@pages/LandingPage/TechVendorsFAQ'
import { TechVendorsFeatures } from '@pages/LandingPage/TechVendorsFeatures'
import { TechVendorsPricing } from '@pages/LandingPage/TechVendorsPricing'
import { WhitePaper } from '@pages/LandingPage/WhitePaper'
import { WhitePaperView } from '@pages/LandingPage/WhitePaperView'

import { BlogPostType, PublicWhitePaperType } from '@utils/types'

const LandingPageTemplate = lazy(async () => {
  const { LandingPageTemplate } = await import('@pages/LandingPage/Template')
  return { default: LandingPageTemplate }
})

const Disclaimer = lazy(async () => {
  const { Disclaimer } = await import('@pages/LandingPage/Disclaimer')
  return { default: Disclaimer }
})

const PrivacyPolicy = lazy(async () => {
  const { PrivacyPolicy } = await import('@pages/LandingPage/PrivacyPolicy')
  return { default: PrivacyPolicy }
})

const TermsAndConditions = lazy(async () => {
  const { TermsAndConditions } = await import(
    '@pages/LandingPage/TermsAndConditions'
  )
  return { default: TermsAndConditions }
})

const AgencyTermsAndConditions = lazy(async () => {
  const { AgencyTermsAndConditions } = await import(
    '@pages/LandingPage/AgencyTermsAndConditions'
  )
  return { default: AgencyTermsAndConditions }
})

const LandingPageTemplateWithSuspense = withSuspense(LandingPageTemplate)
const DisclaimerWithSuspense = withSuspense(Disclaimer)
const PrivacyPolicyWithSuspense = withSuspense(PrivacyPolicy)
const TermsAndConditionsWithSuspense = withSuspense(TermsAndConditions)

const LandingPageRoutes = () => (
  <Routes>
    <Route element={<LandingPageTemplateWithSuspense />}>
      <Route path="/" element={<Home />} />
      <Route path="/features" element={<Features />} />
      <Route path="/story" element={<About />} />
      <Route path="/about" element={<About />} />
      <Route path="/tech-vendors" element={<TechVendorsBenefits />} />
      <Route path="/tech-vendors-benefits" element={<TechVendorsBenefits />} />
      <Route path="/tech-vendors-features" element={<TechVendorsFeatures />} />
      <Route path="/pricing" element={<TechVendorsPricing />} />
      <Route path="/tech-vendors-pricing" element={<TechVendorsPricing />} />
      <Route path="/tech-vendors-faq" element={<TechVendorsFAQ />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/press" element={<Press />} />
      <Route path="/blog" element={<Blog page={BlogPostType.IT_CUSTOMER} />} />
      <Route
        path="/blog/it-customer"
        element={<Blog page={BlogPostType.IT_CUSTOMER} />}
      />
      <Route
        path="/blog-it-customer"
        element={<Blog page={BlogPostType.IT_CUSTOMER} />}
      />
      <Route
        path="/blog/tech-vendor"
        element={<Blog page={BlogPostType.TECH_VENDOR} />}
      />
      <Route
        path="/blog-tech-vendor"
        element={<Blog page={BlogPostType.TECH_VENDOR} />}
      />
      <Route
        path="/blog/it-customer/:blogPostSlug"
        element={<BlogPostView page={BlogPostType.IT_CUSTOMER} />}
      />
      <Route
        path="/blog/tech-vendor/:blogPostSlug"
        element={<BlogPostView page={BlogPostType.TECH_VENDOR} />}
      />

      <Route
        path="/whitepapers"
        element={<WhitePaper page={PublicWhitePaperType.IT_CUSTOMER} />}
      />
      <Route
        path="/whitepapers/it-customer"
        element={<WhitePaper page={PublicWhitePaperType.IT_CUSTOMER} />}
      />
      <Route
        path="/whitepapers-it-customer"
        element={<WhitePaper page={PublicWhitePaperType.IT_CUSTOMER} />}
      />
      <Route
        path="/whitepapers/tech-vendor"
        element={<WhitePaper page={PublicWhitePaperType.TECH_VENDOR} />}
      />
      <Route
        path="/whitepapers-tech-vendor"
        element={<WhitePaper page={PublicWhitePaperType.TECH_VENDOR} />}
      />
      <Route
        path="/whitepapers/it-customer/:whitePaperSlug"
        element={<WhitePaperView page={PublicWhitePaperType.IT_CUSTOMER} />}
      />
      <Route
        path="/whitepapers/tech-vendor/:whitePaperSlug"
        element={<WhitePaperView page={PublicWhitePaperType.TECH_VENDOR} />}
      />
    </Route>

    <Route path="/disclaimer" element={<DisclaimerWithSuspense />} />
    <Route
      path="/terms-conditions"
      element={<TermsAndConditionsWithSuspense />}
    />
    <Route
      path="/terms-and-conditions"
      element={<TermsAndConditionsWithSuspense />}
    />
    <Route
      path="/agency-terms-and-conditions"
      element={<AgencyTermsAndConditions />}
    />
    <Route path="/privacy-policy" element={<PrivacyPolicyWithSuspense />} />

    <Route path="*" element={<NavigateTo path="/404" replace />} />
  </Routes>
)

export { LandingPageRoutes }
